import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { EntitySteps, OnboardingStep } from '../../utils/constants';

export const completeStep = createAsyncThunk(
	'onboarding/completeStepAndSave',
	async ({ step, userId, data }, { dispatch, getState }) => {
		const state = getState();
		const currentOnboardingSteps = state.onboarding.steps;
		const currentOnboardingData = state.onboarding.data;
		var onboardingData = currentOnboardingData;

		if (EntitySteps.includes(step)) {
			const isDataValid = data !== undefined && data !== null;

			onboardingData = {
				...onboardingData,
				[step]: isDataValid ? data : null,
			};
		}

		const updatedSteps = {
			onboardingSteps: {
				...currentOnboardingSteps,
				[step]: true,
			},
			onboardingData: {
				...onboardingData,
			},
		};

		dispatch(updateStep({ step }));
		dispatch(updateData(onboardingData));

		const response = await axios.post(`/api/users/${userId}`, {
			...updatedSteps,
		});

		return response.data.message;
	}
);

export const updateOnboardingState = createAsyncThunk(
	'onboarding/updateState',
	async (
		{ userId, steps, data, isHidden, isOnboardingComplete },
		{ getState }
	) => {
		const state = getState().onboarding;

		const updatedState = {
			onboardingSteps: steps || state.steps,
			onboardingData: data || state.data,
			onboardingHidden: isHidden !== undefined ? isHidden : state.isHidden,
			onboarding:
				isOnboardingComplete !== undefined
					? isOnboardingComplete
					: state.isOnboardingComplete,
		};

		const response = await axios.post(`/api/users/${userId}`, updatedState);
		return response.data;
	}
);

const onboardingSlice = createSlice({
	name: 'onboarding',
	initialState: {
		active: false,
		currentStep: OnboardingStep.NAVIGATE_TO_USERS_PAGE,
		isOnboardingComplete: false,
		steps: {
			[OnboardingStep.NAVIGATE_TO_USERS_PAGE]: false,
			[OnboardingStep.CREATE_NEW_USER]: false,
			[OnboardingStep.NAVIGATE_TO_WORKOUT_LIBRARY]: false,
			[OnboardingStep.FILL_WORKOUT_FORM]: false,
			[OnboardingStep.CREATE_NEW_EXERCISE]: false,
			[OnboardingStep.CREATE_NEW_WORKOUT]: false,
			[OnboardingStep.NAVIGATE_TO_SCHEDULE]: false,
			[OnboardingStep.ADD_WORKOUT_TO_SCHEDULE]: false,
			[OnboardingStep.OPEN_WORKOUT_MODAL]: false,
			[OnboardingStep.TRACK_WORKOUT_FOR_ATHLETE]: false,
			[OnboardingStep.VISIT_COMPLETED_WORKOUT]: false,
		},
		data: {
			[OnboardingStep.CREATE_NEW_USER]: null,
			[OnboardingStep.CREATE_NEW_WORKOUT]: null,
			[OnboardingStep.ADD_WORKOUT_TO_SCHEDULE]: null,
		},
		isHidden: false,
	},
	reducers: {
		updateSteps: (state, action) => {
			state.steps = action.payload;

			state.isOnboardingComplete = Object.values(state.steps).every(
				(step) => step === true
			);
		},
		updateData: (state, action) => {
			state.data = action.payload;
		},
		setCurrentStep: (state, action) => {
			state.currentStep = action.payload;
		},
		setActiveOnboarding: (state, action) => {
			state.active = action.payload;
		},
		updateStep: (state, action) => {
			const { step } = action.payload;
			state.steps[step] = true;

			const stepOrder = Object.keys(OnboardingStep);
			const currentIndex = stepOrder.indexOf(step);

			if (currentIndex < stepOrder.length - 1) {
				state.currentStep = OnboardingStep[stepOrder[currentIndex + 1]];
			} else {
				state.isOnboardingComplete = true;
			}
		},
		hideOnboarding: (state, action) => {
			state.isHidden = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(updateOnboardingState.fulfilled, (state, action) => {
				const userData = action.payload.user;
				state.steps = userData.onboardingSteps;
				state.data = userData.onboardingData;
				state.isHidden = userData.onboardingHidden;
				state.isOnboardingComplete = userData.onboarding;
				console.log('Onboarding state updated successfully');
			})
			.addCase(updateOnboardingState.rejected, (state, action) => {
				console.error('Failed to update onboarding state:', action.error);
			});
	},
});

export const {
	setActiveOnboarding,
	setCurrentStep,
	updateStep,
	updateSteps,
	updateData,
	hideOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
